import { sendUnityEvent } from '../../components/container/unityContainer';
import { curatorTextureUploadFailedDialogActions } from '../../redux/slicers/admin/curatorTextureUploadFailedDialogSlicer';
import { paginatedTexturesSelectors, selectPendingUploadIds } from '../../redux/slicers/textures/paginatedTexturesSlicer';
import { getAppState } from '../../redux/store';
import { dispatcher } from '../projectHelper';
import { errorToast } from '../toastHelper';
import { UnityEvent, waitForEventOnce } from '../unityPubSub';

const validateTexturesUploaded = async () => {
  const notUploadedTextureIds = selectPendingUploadIds(getAppState());

  const texturesInfoList = await waitForEventOnce(UnityEvent.OnReceiveIsUsedStatusOfTextures, () => {
    const params = notUploadedTextureIds.map(id => ({ textureId: parseInt(id) }));
    sendUnityEvent('RoomModule', 'CheckIfTexturesUsedReceiver', JSON.stringify(params))
  })

  const hasTextureUsedInProject = texturesInfoList.some(item => item.isUsed);

  if (hasTextureUsedInProject) {
    errorToast('Please wait... Some textures which are used in this project are still uploading', {
      // toastId: 'PLEASE_WAIT_EXPORT',
      autoClose: 6000,
    });
    return false;
  }


  // check if texture upload failed
  const uploadFailedList = paginatedTexturesSelectors.selectAllFailedUpload(getAppState())

  if (uploadFailedList) {
    const failedTextureUploadIds = uploadFailedList.map(u => u.id);

    const failedTexturesInfoList = await waitForEventOnce(UnityEvent.OnReceiveIsUsedStatusOfTextures, () => {
      const params = failedTextureUploadIds.map(id => ({ textureId: parseInt(id) }));
      sendUnityEvent('RoomModule', 'CheckIfTexturesUsedReceiver', JSON.stringify(params))
    })

    const hasTextureFailedUsedInProject = failedTexturesInfoList.some(item => item.isUsed);

    if (hasTextureFailedUsedInProject) {
      dispatcher(curatorTextureUploadFailedDialogActions.setUnityDetails(failedTexturesInfoList));
      dispatcher(curatorTextureUploadFailedDialogActions.setOpen(true));
      return false;
    }
  }

  return true;
}

export const canExportProject = async () => {
  return await validateTexturesUploaded()
};

export const canCreateRoom = async () => {
  return await validateTexturesUploaded()
}

export const canGenerateRenderOrPreview = async () => {
  return await validateTexturesUploaded()
}

export const canCreateAutomation = async () => {
  return await validateTexturesUploaded()
}